export const IMG = {
  hero: "https://images.unsplash.com/photo-1743677077216-00a458eff9e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  drone: "https://images.unsplash.com/photo-1521405924368-64c5b84bec60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  robot: "https://images.unsplash.com/photo-1742767069929-0c663150b164?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  circuit: "https://images.unsplash.com/photo-1562408590-e32931084e23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  rocket: "https://images.unsplash.com/photo-1517976487492-5750f3195933?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  shuttle: "https://images.unsplash.com/photo-1628126235206-5260b9ea6441?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  ai: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aiSphere: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const CATEGORY_IMG = {
  "Microcontrollers & Boards": "/products/microcontrollers.png",
  Sensors: "/products/sensors.png",
  "Motors & Servos": "/products/motors.png",
  "Motor Drivers & ESCs": "/products/drivers.png",
  "Power Supply": "/products/power-supply.jpg",
  "Drone & Robot Frames": "/products/frames/x500.jpg",
  "Chassis & Frames": "/products/chassis.png",
  "Drone/UAV Specific": "/products/drone-parts.jpg",
  "Connectors & Misc": "/products/misc.png",
};

export const FEATURED_IMG = {
  "prod-robox-app": "/products/robox.jpg",
  "prod-humanoid": "/products/humanoid.png",
  "prod-hotel": "/products/hotel.png",
  "prod-iot": "/products/iot.png",
};

export const PROGRAMS = {
  ai: {
    key: "AI",
    title: "Artificial Intelligence",
    tagline: "From first prompt to first model — students build real AI that sees, speaks and decides.",
    image: IMG.ai,
    accent: "#00E5FF",
    outcomes: ["Train image & voice classifiers", "Build chatbots and AI assistants", "Apply AI ethically to local problems", "Ship AI features into RoboSpark IoT products"],
    tools: ["Python", "Teachable Machine", "TensorFlow Lite", "OpenCV", "Raspberry Pi", "Jetson Nano"],
    levels: [
      { grade: "Class 6–8", name: "AI Explorers", topics: ["What is AI? Patterns & data", "Block coding with AI extensions", "Image recognition with Teachable Machine", "Voice assistants & smart speakers", "Mini project: Smart attendance counter"] },
      { grade: "Class 9–10", name: "AI Builders", topics: ["Python fundamentals & data handling", "Machine learning: regression & classification", "Computer vision with OpenCV", "NLP basics & chatbots", "Project: Face-recognition door lock"] },
      { grade: "Class 11–12", name: "AI Engineers", topics: ["Neural networks & deep learning", "Edge AI on Jetson Nano / Pi", "Generative AI & prompt engineering", "AI in robotics & drones (autonomy)", "Capstone: Deployable AI product for Roboshop"] },
    ],
  },
  robotics: {
    key: "Robotics",
    title: "Robotics & Humanoids",
    tagline: "Design, wire, code and sell — robots built by students that leave the classroom.",
    image: IMG.robot,
    accent: "#FF2E63",
    outcomes: ["Build line-follower, obstacle & arm robots", "Master sensors, motors & microcontrollers", "Design humanoid and service robots", "Assemble robots sold under RoboSpark brand"],
    tools: ["Arduino", "ESP32", "Servo & BLDC motors", "Fusion 360", "3D printing", "ROS basics"],
    levels: [
      { grade: "Class 6–8", name: "Robo Starters", topics: ["Circuits, LEDs & breadboards", "Arduino basics & block coding", "Sensors: IR, ultrasonic, LDR", "Line follower & obstacle avoider", "Project: Smart dustbin"] },
      { grade: "Class 9–10", name: "Robo Makers", topics: ["Motor drivers & PWM control", "Bluetooth/Wi-Fi controlled robots", "Robotic arm with servos", "IoT home automation", "Project: Household AI IoT kit"] },
      { grade: "Class 11–12", name: "Robo Engineers", topics: ["Kinematics & control systems", "ROS & SLAM navigation", "Humanoid gait & balance", "Hotel service robot design", "Capstone: Commercial robot prototype"] },
    ],
  },
  uav: {
    key: "UAV",
    title: "UAV / Drone Technology",
    tagline: "Assemble, tune and fly — drone pilots and builders for India's fast-growing UAV economy.",
    image: IMG.drone,
    accent: "#00E5FF",
    outcomes: ["Understand flight physics & aerodynamics", "Assemble & calibrate quadcopters", "Program autonomous missions", "Prepare for DGCA drone careers"],
    tools: ["F450 / S500 frames", "Pixhawk", "Betaflight", "Mission Planner", "FPV systems", "Simulators"],
    levels: [
      { grade: "Class 6–8", name: "Sky Cadets", topics: ["How things fly: lift, thrust, drag", "Drone parts & safety rules", "Simulator flying practice", "Mini drone indoor flight", "Project: Paper glider challenge"] },
      { grade: "Class 9–10", name: "Drone Builders", topics: ["Brushless motors, ESCs & LiPo", "Quadcopter assembly (F450)", "Flight controller tuning", "FPV camera & video links", "Project: Build & fly your own drone"] },
      { grade: "Class 11–12", name: "UAV Engineers", topics: ["GPS waypoint missions (Pixhawk)", "Agri-spraying & survey drones", "Computer vision on drones", "Drone regulations (DGCA)", "Capstone: Mission-ready UAV"] },
    ],
  },
  aerospace: {
    key: "Aerospace",
    title: "Aerospace Engineering",
    tagline: "Rockets, satellites and beyond — a launchpad for India's next generation of space engineers.",
    image: IMG.rocket,
    accent: "#FF2E63",
    outcomes: ["Learn orbital mechanics basics", "Build & launch water/model rockets", "Design CanSat mini satellites", "Explore ISRO & space-tech careers"],
    tools: ["OpenRocket", "CanSat kits", "Arduino telemetry", "CAD design", "Wind tunnel demos", "Sensors & GPS"],
    levels: [
      { grade: "Class 6–8", name: "Space Explorers", topics: ["Solar system & space missions", "Newton's laws with rockets", "Water rocket build & launch", "Parachute recovery design", "Project: Bottle rocket competition"] },
      { grade: "Class 9–10", name: "Rocket Makers", topics: ["Aerodynamics & stability", "Model rocket simulation (OpenRocket)", "Telemetry with sensors", "Aircraft structures & materials", "Project: Telemetry rocket"] },
      { grade: "Class 11–12", name: "Aerospace Engineers", topics: ["Orbital mechanics & propulsion", "CanSat satellite design", "Ground station communication", "Space-tech entrepreneurship", "Capstone: CanSat competition entry"] },
    ],
  },
};

export const PROJECTS = [
  { id: 1, title: "Humanoid 'Spark-1'", category: "Robotics", school: "RoboSpark Lab, Patna", image: "/products/humanoid.png" },
  { id: 2, title: "Agri Survey Drone", category: "UAV", school: "Partner School, Ranchi", image: IMG.drone },
  { id: 3, title: "Face-Recognition Attendance", category: "AI", school: "RoboSpark Lab, Kolkata", image: IMG.aiSphere },
  { id: 4, title: "Telemetry Water Rocket", category: "Aerospace", school: "Partner School, Bhubaneswar", image: IMG.shuttle },
  { id: 5, title: "Hotel Service Bot", category: "Robotics", school: "RoboSpark Lab, Noida", image: "/products/hotel.png" },
  { id: 6, title: "Smart Home IoT Kit", category: "AI", school: "Partner School, Gaya", image: "/products/iot.png" },
  { id: 7, title: "Quadcopter Build Workshop", category: "UAV", school: "RoboSpark Lab, Jamshedpur", image: "/products/drone.png" },
  { id: 8, title: "Robot Prototype Showcase", category: "Robotics", school: "RoboSpark Expo 2025", image: IMG.robot },
  { id: 9, title: "CanSat Launch Prep", category: "Aerospace", school: "RoboSpark Lab, Bhubaneswar", image: IMG.rocket },
  { id: 10, title: "Students & Robot Day", category: "Events", school: "RoboSpark Annual Fest", image: IMG.hero },
  { id: 11, title: "Circuit Design Bootcamp", category: "Events", school: "Noida Innovation Hub", image: IMG.circuit },
  { id: 12, title: "AI Vision Lab", category: "AI", school: "Partner School, Lucknow", image: IMG.ai },
];

export const TESTIMONIALS = [
  { name: "Aarav Kumar", role: "Class 10, Patna", text: "I built my first drone in 6 weeks — and my team's IoT kit was actually sold on Roboshop. I earned my first ₹4,000!" },
  { name: "Mrs. Sunita Mishra", role: "Principal, Ranchi", text: "RoboSpark set up a complete lab in our school. Students now look forward to every Saturday." },
  { name: "Rahul Sen", role: "Parent, Kolkata", text: "My daughter talks about rockets and satellites at dinner. The Learn & Earn model gave her real confidence." },
];
